import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { ApiModule, Configuration } from '../api/gen';
import { environment } from '../environments/environment';
import { readStationProxy } from './station-proxy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom(ApiModule),
    {
      // Point the generated OpenAPI client at this station's backend. The public payment endpoints are
      // anonymous, so no auth credentials are configured. On a kiosk with a signing proxy the calls go to
      // the proxy on the station's own Pi instead, which signs them with the terminal's key and forwards
      // them to the same backend (see station-proxy.ts). Phones never have a proxy, so the settlement
      // page (which builds its own Configuration anyway) is unaffected.
      provide: Configuration,
      useFactory: () => new Configuration({ basePath: readStationProxy() ?? environment.apiUrl.replace(/\/+$/, '') }),
    },
  ],
};
